import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import ur from './locales/ur.json';
import bn from './locales/bn.json';
import tl from './locales/tl.json';

/** Languages shown in the switcher. Workforce languages (hi, ur, bn, tl) cover the operator app; admin/partner screens fall back to English. */
export const LANGUAGES: { code: string; label: string; workforceOnly?: boolean }[] = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'hi', label: 'हिन्दी', workforceOnly: true },
  { code: 'ur', label: 'اردو', workforceOnly: true },
  { code: 'bn', label: 'বাংলা', workforceOnly: true },
  { code: 'tl', label: 'Filipino', workforceOnly: true },
];

export const RTL_LANGUAGES = new Set(['ar', 'ur', 'fa', 'he']);

export function applyDirection(lng: string) {
  const dir = RTL_LANGUAGES.has(lng.split('-')[0]) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
}

/** Call once per app before rendering. Pass `workforce: true` (operator app) to enable hi/ur/bn/tl; other apps keep EN/AR. */
export function setupI18n(extraResources: Record<string, Record<string, unknown>> = {}, options: { workforce?: boolean } = {}) {
  if (i18n.isInitialized) return i18n;
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: en },
        ar: { translation: ar },
        ...(options.workforce ? { hi: { translation: hi }, ur: { translation: ur }, bn: { translation: bn }, tl: { translation: tl } } : {}),
        ...Object.fromEntries(Object.entries(extraResources).map(([k, v]) => [k, { translation: v }])),
      },
      fallbackLng: 'en',
      supportedLngs: ['en', 'ar', ...(options.workforce ? ['hi', 'ur', 'bn', 'tl'] : []), ...Object.keys(extraResources)],
      interpolation: { escapeValue: false },
      detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'], lookupLocalStorage: 'gr.lang' },
    });
  applyDirection(i18n.resolvedLanguage ?? 'en');
  i18n.on('languageChanged', applyDirection);
  return i18n;
}

export default i18n;
